<app-breadcrumbs title="Supplier" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5>Suppliers</h5>
    <button class="btn btn-success" (click)="toggleForm()">
      <i [class]="showForm ? 'ri-close-line' : 'ri-add-line'"></i>
      {{ showForm ? 'Cancel' : 'Add Suppliers' }}
    </button>
  </div>

  <div *ngIf="showForm" class="card-body border-bottom">
    <form [formGroup]="suppliersForm" (ngSubmit)="saveSuppliers()">
      <div class="row g-3">
        <div class="col-md-3">
          <label>Name</label>
          <input formControlName="name" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>Code</label>
          <input formControlName="code" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>Contact Person</label>
          <input formControlName="contactPerson" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>Email</label>
          <input formControlName="email" type="email" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>Mobile</label>
          <input formControlName="mobile" type="text" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>Address</label>
          <input formControlName="address" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>City</label>
          <input formControlName="city" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>State</label>
          <input formControlName="state" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>Pincode</label>
          <input formControlName="pincode" class="form-control" />
        </div>

        <div class="col-md-3">
          <label>GST Number</label>
          <input formControlName="gstNumber" class="form-control" />
        </div>

        <div class="col-md-3 d-flex align-items-center">
          <input type="checkbox" formControlName="is_active" class="form-check-input me-2" />
          <label>Active</label>
        </div>
      </div>

      <div class="mt-3 text-end">
        <button class="btn btn-light" type="button" (click)="toggleForm()">Cancel</button>
        <button class="btn btn-success" type="submit">{{ isEditMode ? 'Update' : 'Save' }}</button>
      </div>
    </form>
  </div>

  <div class="card-body" style="overflow: auto;">
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div *ngIf="!isLoading">
      <table class="table">
        <thead class="table-light">
          <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Contact Person</th>
            <th>Mobile Number</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>GST No.</th>
            <th>City</th>
            <th>State</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let supplier of suppliers">
          <td>{{ supplier?.name }}</td>
          <td>{{ supplier?.code }}</td>
          <td>{{ supplier?.contactPerson }}</td>
          <td>{{ supplier?.mobile }}</td>
          <td>{{ supplier?.email }}</td>
          <td>{{ supplier?.mobile }}</td>
          <td>{{ supplier?.gstNumber }}</td>
          <td>{{ supplier?.city }}</td>
          <td>{{ supplier?.state }}</td>
          <td>
            <span [ngClass]="supplier.isActive ? 'true' : 'text-danger'">
              {{ supplier.isActive ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td class="d-flex gap-2">
            <button class="btn btn-sm btn-success" (click)="editSuppliers(supplier)"><i class="ri-edit-2-line"></i></button>
            <button class="btn btn-sm btn-danger" (click)="deleteSuppliers(supplier.id)"><i class="ri-delete-bin-line"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <div *ngIf="suppliers.length > 0 && !isLoading" class="mb-2 row">
        <div class="dataTables_info mb-2 col col-sm-6">
            Showing {{ (page - 1) * pageSize + 1 }}
            to {{ getMin(page * pageSize, totalItems) }}
            of {{ totalItems }} entries
        </div>
        <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
                <ngb-pagination
                    [collectionSize]="totalItems"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="changePage($event)">
                </ngb-pagination>
            </div>
        </div>
    </div>
  </div>
</div>

  </div>
</div>
